<template>
  <div class="card-container">
    <common-el-form
      :model="model"
      :submitData="submitData"
      @success="onSuccess"
      ref="model"
      :showButton="false"
      :inline="true"
      :SubmitButton="true"
      submit-btn-text="查询"
      failTitle="提交失败"
      loadingText="提交中..."
      :submitService="submitService"
    >
      <!-- <el-form-item :rules="startAge" label="年龄范围" prop="startAge">
        <div style="display: flex">
          <div style="margin-right: 5px">
            <el-input v-model="model.startAge" placeholder="请输入"></el-input>
          </div>
          ~
          <div style="margin-left: 5px">
            <el-input v-model="model.endAge" placeholder="请输入"></el-input>
          </div>
        </div>
      </el-form-item> -->
      <el-form-item :rules="startAge" label="年龄范围" prop="startAge">
        <el-input-number
          v-model="model.startAge"
          :min="1"
          :max="100"
          :step="0"
          :precision="0"
          :controls="false"
          placeholder="起始"
          @change="bian"
        ></el-input-number>
      </el-form-item>
      <el-form-item :rules="endAge" label="" prop="endAge">
        <el-input-number
          v-model="model.endAge"
          :min="1"
          :max="100"
          :step="0"
          :precision="0"
          :controls="false"
          placeholder="结束"
          @change="bian"
        ></el-input-number>
      </el-form-item>
    </common-el-form>
    <div id="test_app">
      <div id="main" style="width: 100%; height: 680px; background: #fff"></div>
    </div>
  </div>
</template>
 
<script>
import echarts from "echarts";
import CommonElForm from "components/common/CommonElForm";
import StatisticsService from "service/StatisticsService";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "ecagelinechart",
  components: {
    CommonElForm,
  },
  data() {
    return {
      model: {
        startAge: "",
        endAge: "",
      },
      submitService: StatisticsService.ecagelinechartList,
      charts: "",
      opinionData: [], //数据
      startAge: [
        {
          required: true,
          validator: (rule, value, callback) => {
            // console.log(value);
            const endAgeDiff = this.model.endAge - value;
            if (endAgeDiff < 0) {
              callback(new Error("起始年龄不能大于结束年龄"));
            } else if (endAgeDiff > 30) {
              callback(new Error("年龄范围差不能超过30"));
            } else {
              callback();
            }
          },
        },
      ],
      endAge: [
        {
          required: true,
          validator: (rule, value, callback) => {
            const startAgeDiff = value - this.model.startAge;
            if (startAgeDiff < 0) {
              callback(new Error("结束年龄不能小于起始年龄"));
            } else if (startAgeDiff > 30) {
              callback(new Error("年龄范围差不能超过30"));
            } else {
              callback();
            }
          },
        },
      ],
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.$nextTick(function () {
      this.drawLine("main");
    });
    this.load();
  },
  computed: {
    submitData() {
      const params = {
        startAge: this.model.startAge,
        endAge: this.model.endAge,
      };
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  methods: {
    bian() {
      this.$refs.model.validateField("startAge");
      this.$refs.model.validateField("endAge");
    },
    load() {
      this.model = {};
      // this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        const xAxisData = result.map((item) => item.name);
        const yAxisData = result.map((item) => item.value);
        // 将xAxisData和yAxisData作为折线图的X轴和Y轴数据
        this.charts.setOption({
          xAxis: {
            data: xAxisData,
          },
          series: [
            {
              data: yAxisData,
            },
          ],
        });
      });
    },
    drawLine(id) {
      this.charts = echarts.init(document.getElementById(id));
      this.charts.setOption({
        tooltip: {
          trigger: "axis",
        },
        legend: {
          align: "right", //文字在前图标在后
          left: "3%",
          top: "15%",
          data: ["近一周"],
        },
        grid: {
          x: 40,
          y: 60,
          x2: 50,
          y2: 20,
          containLabel: true, // 自动计算合适的边距
        },
        // toolbox: {//保存为图片
        //   feature: {
        //     saveAsImage: {},
        //   },
        // },
        xAxis: {
          type: "category",
          boundaryGap: true,
          name: "年龄", // x轴标注名称
          axisTick: {
            alignWithLabel: true, //保证刻度线和标签对齐
          },
          data: [], //x坐标的名称
          // axisLabel: { rotate: 45 },
        },
        yAxis: {
          type: "value",
          boundaryGap: true,
          name: "数量(人)", // x轴标注名称
          splitNumber: 10, //纵坐标数
          interval: 1, //强制设置坐标轴分割间隔
          splitLine: {
            show: true, // 显示纵向网格线
          },
          axisLabel: {
            formatter: function (value) {
              if (value % 1 === 0) {
                return value;
              } else {
                return "";
              }
            },
          },
        },
        // dataZoom: [ //X轴拖拽
        //   {
        //     type: "slider",
        //     start: 0,
        //     end: 30,
        //     // 最大的放大是图形的2%
        //     maxSpan: 30,
        //   },
        //   {
        //     start: 0,
        //     end: 30,
        //   },
        // ],

        series: [
          {
            name: "数量(人)",
            type: "line", //折线图line;柱形图bar;饼图pie
            data: [],
            symbol: "circle", //修改交叉点样式
            symbolSize: 15, //修改交叉点大小
            label: {
              show: false,
              position: "right",
              textStyle: {
                fontSize: 10,
              },
            },
            itemStyle: {
              normal: {
                color: "#f90",
              },
            },
            lineStyle: {
              color: "#f90",
            },
            itemStyle: {
              color: "rgb(255,96,64)", //改变折线点的颜色
              lineStyle: {
                color: "rgb(255,96,64)", //改变折线颜色
              },
            },
            data: this.opinionData,
          },
        ],
      });
    },
  },
};
</script>
 
<style scoped>
</style>


// WEBPACK FOOTER //
// src/view/page/Statistics/EcAgeLineChart.vue